import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const usePermamentlyDeleteMutation = (parentType) => {
  const slug = Angie.functions.slug(parentType);
  return useMutation({
    mutationFn: (id) => {
      return fetch({
        url: `${Angie.api_url}/permanently-delete/${slug}/${id}`,
        method: "DELETE",
      });
    },
  });
};
